/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
@Component({
  templateUrl:'./signInTaskEdit.html'
})

export class SignInTaskEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location
  ){}

  private data:any={
    "descriptionEn": "",
    "descriptionTc": "",
    "id": "",
    "name": "",
    "titleEn": "",
    "titleTc": ""
  }

  private id:number = 0;

  private isCreate:boolean=false;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });

    if(this.id!=0){
      this.getData();
    }else {
      this.isCreate = true;
    }
  }





  private getData():void{
    this.HttpService.getData(API.sign_in+'/'+this.id).then(res=>{
      this.data = res.data;
    })
  }

  private submit():void{
    this.HttpService.postData(API.sign_in_createOrUpdate,{
      'id':this.id,
      "describeEn": this.data.describeEn,
      "describeTc": this.data.describeTc,
      "titleEn":this.data.titleEn,
      "titleTc": this.data.titleTc
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
      }else{
        alert(data.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/badge/signInTaskEdit.component.ts